import { Text } from '@belong/ui';
import { HOME_PAGE_STRINGS } from 'src/features/home-page/home-page.strings';

export function SeoHint() {
  return (
    <div className="mt-xs h-xs container relative flex justify-end text-right md:mt-0">
      <Text as="h1" variant="p2" className="bottom-xs text-dark-gray absolute">
        {HOME_PAGE_STRINGS['seoHint']}
      </Text>
    </div>
  );
}
